export function getdata() {
	let obj = {

			headDatas:[
					{
						title: "负债和所有者权益",
						children: [{
							title:'',
							prop:'',
							children: [{
								custom: true,
								prop: "title",
								title: "流动负债：",
							}]
						}]
					}, {

						title: "行次",
						children: [{
							children: [{
								prop: "grade",
								custom: true,
							}]
						}]
					}, {
						title:'',
						prop:'',
						children: [{
							title: "期末余额",
							children: [{
								custom: true,
								prop: "cwbbxqykjzz_0_x_1",
							}]
						}, ]
					},
					{
						title:'',
						prop:'',
						children: [{
							title: "年初余额",
							custom: true,
							children: [{
								custom: true,
								prop: "cwbbxqykjzz_0_x_2",
							}]
						}, ]
					},
			],
			headData: [{
					title: "资    产",
					prop: "title",
					children: [{
						title:'',
						prop:'',
						children:[{
							prop:'title',
							title: "流动资产：",
							width: "250px",
							custom: true,
							}]
					}]
				},
				{
					title: "行次",
					children: [{
						title:'',
						prop:'',
						children: [{
							title:'',
							prop: "grade",
							custom: true,
							width: "100px"
						}]
					}]
				},
				{
					title:'',
					prop:'',
					children: [{
						title: "期末余额",
						children: [{
							width: "200px",
							prop: "cwbbxqykjzz_0_x_1",
							custom: true,
						}]
					}, ]
				},
				{
					title:'',
					prop:'',
					children: [{
						title: "年初余额",
						children: [{
							width: "200px",
							custom: true,
							prop: "cwbbxqykjzz_0_x_2",
						}]
					}, ]
				},
			],
			tableDatas:[{
					grade: "31",
					title:'短期借款',
					disabledcwbbxqykjzz_0_x_1:false,
					disabledcwbbxqykjzz_0_x_2:false,
					cwbbxqykjzz_0_x_1: {
						cellCode:"cwbbxqykjzz_0_1_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_0_x_2: {
						cellCode:"cwbbxqykjzz_0_1_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					grade: "32",
					title:'应付票据',
					disabledcwbbxqykjzz_0_x_1:false,
					disabledcwbbxqykjzz_0_x_2:false,
					cwbbxqykjzz_0_x_1: {
						cellCode:"cwbbxqykjzz_0_2_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_0_x_2: {
						cellCode:"cwbbxqykjzz_0_2_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					grade: "33",
					title:'应付账款',
					disabledcwbbxqykjzz_0_x_1:false,
					disabledcwbbxqykjzz_0_x_2:false,
					cwbbxqykjzz_0_x_1: {
						cellCode:"cwbbxqykjzz_0_3_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_0_x_2: {
						cellCode:"cwbbxqykjzz_0_3_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					grade: "34",
					title:'预收账款',
					disabledcwbbxqykjzz_0_x_1:false,
					disabledcwbbxqykjzz_0_x_2:false,
					cwbbxqykjzz_0_x_1: {
						cellCode:"cwbbxqykjzz_0_4_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_0_x_2: {
						cellCode:"cwbbxqykjzz_0_4_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					grade: "35",
					title:'应付职工薪酬',
					disabledcwbbxqykjzz_0_x_1:false,
					disabledcwbbxqykjzz_0_x_2:false,
					cwbbxqykjzz_0_x_1: {
						cellCode:"cwbbxqykjzz_0_5_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_0_x_2: {
						cellCode:"cwbbxqykjzz_0_5_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					grade: "36",
					title:'应交税费',
					disabledcwbbxqykjzz_0_x_1:false,
					disabledcwbbxqykjzz_0_x_2:false,
					cwbbxqykjzz_0_x_1: {
						cellCode:"cwbbxqykjzz_0_6_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_0_x_2: {
						cellCode:"cwbbxqykjzz_0_6_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					grade: "37",
					title:'应付利息',
					disabledcwbbxqykjzz_0_x_1:false,
					disabledcwbbxqykjzz_0_x_2:false,
					cwbbxqykjzz_0_x_1: {
						cellCode:"cwbbxqykjzz_0_7_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_0_x_2: {
						cellCode:"cwbbxqykjzz_0_7_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					grade: "38",
					title:'应付利润',
					disabledcwbbxqykjzz_0_x_1:false,
					disabledcwbbxqykjzz_0_x_2:false,
					cwbbxqykjzz_0_x_1: {
						cellCode:"cwbbxqykjzz_0_8_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_0_x_2: {
						cellCode:"cwbbxqykjzz_0_8_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					grade: "39",
					title:'其他应付款',
					disabledcwbbxqykjzz_0_x_1:false,
					disabledcwbbxqykjzz_0_x_2:false,
					cwbbxqykjzz_0_x_1: {
						cellCode:"cwbbxqykjzz_0_9_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_0_x_2: {
						cellCode:"cwbbxqykjzz_0_9_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					grade: "40",
					title:'其他流动负债',
					disabledcwbbxqykjzz_0_x_1:false,
					disabledcwbbxqykjzz_0_x_2:false,
					cwbbxqykjzz_0_x_1: {
						cellCode:"cwbbxqykjzz_0_10_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_0_x_2: {
						cellCode:"cwbbxqykjzz_0_10_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					grade: "41",
					title:'流动负债合计',
					disabledcwbbxqykjzz_0_x_1:false,
					disabledcwbbxqykjzz_0_x_2:false,
					cwbbxqykjzz_0_x_1: {
						cellCode:"cwbbxqykjzz_0_11_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_0_x_2: {
						cellCode:"cwbbxqykjzz_0_11_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					grade: "",
					title:'非流动负债',
					disabledcwbbxqykjzz_0_x_1:true,
					disabledcwbbxqykjzz_0_x_2:true,
					cwbbxqykjzz_0_x_1: {
						cellCode:"cwbbxqykjzz_0_12_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_0_x_2: {
						cellCode:"cwbbxqykjzz_0_12_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					grade: "42",
					title:'长期借款',
					disabledcwbbxqykjzz_0_x_1:false,
					disabledcwbbxqykjzz_0_x_2:false,
					cwbbxqykjzz_0_x_1: {
						cellCode:"cwbbxqykjzz_0_13_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_0_x_2: {
						cellCode:"cwbbxqykjzz_0_13_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					grade: "43",
					title:'  长期应付款',
					disabledcwbbxqykjzz_0_x_1:false,
					disabledcwbbxqykjzz_0_x_2:false,
					cwbbxqykjzz_0_x_1: {
						cellCode:"cwbbxqykjzz_0_14_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_0_x_2: {
						cellCode:"cwbbxqykjzz_0_14_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					grade: "44",
					title:'  递延收益',
					disabledcwbbxqykjzz_0_x_1:false,
					disabledcwbbxqykjzz_0_x_2:false,
					cwbbxqykjzz_0_x_1: {
						cellCode:"cwbbxqykjzz_0_15_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_0_x_2: {
						cellCode:"cwbbxqykjzz_0_15_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					grade: "45",
					title:'其他非流动负债',
					disabledcwbbxqykjzz_0_x_1:false,
					disabledcwbbxqykjzz_0_x_2:false,
					cwbbxqykjzz_0_x_1: {},
					cwbbxqykjzz_0_x_2: {},
				},{
					grade: "46",
					title:'  非流动负债合计',
					disabledcwbbxqykjzz_0_x_1:false,
					disabledcwbbxqykjzz_0_x_2:false,
					cwbbxqykjzz_0_x_1: {
						cellCode:"cwbbxqykjzz_0_16_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_0_x_2: {
						cellCode:"cwbbxqykjzz_0_16_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					grade: "47",
					title:'负债合计',
					disabledcwbbxqykjzz_0_x_1:false,
					disabledcwbbxqykjzz_0_x_2:false,
					cwbbxqykjzz_0_x_1: {
						cellCode:"cwbbxqykjzz_0_17_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_0_x_2: {
						cellCode:"cwbbxqykjzz_0_17_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					grade: "",
					title:'',
					disabledcwbbxqykjzz_0_x_1:false,
					disabledcwbbxqykjzz_0_x_2:false,
					cwbbxqykjzz_0_x_1: {
						cellCode:"cwbbxqykjzz_0_18_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_0_x_2: {
						cellCode:"cwbbxqykjzz_0_18_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					grade: "",
					title:'',
					disabledcwbbxqykjzz_0_x_1:false,
					disabledcwbbxqykjzz_0_x_2:false,
					cwbbxqykjzz_0_x_1: {
						cellCode:"cwbbxqykjzz_0_19_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_0_x_2: {
						cellCode:"cwbbxqykjzz_0_19_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					grade: "",
					title:'',
					disabledcwbbxqykjzz_0_x_1:false,
					disabledcwbbxqykjzz_0_x_2:false,
					cwbbxqykjzz_0_x_1: {
						cellCode:"cwbbxqykjzz_0_20_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_0_x_2: {
						cellCode:"cwbbxqykjzz_0_20_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					grade: "",
					title:'',
					disabledcwbbxqykjzz_0_x_1:false,
					disabledcwbbxqykjzz_0_x_2:false,
					cwbbxqykjzz_0_x_1: {
						cellCode:"cwbbxqykjzz_0_21_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_0_x_2: {
						cellCode:"cwbbxqykjzz_0_21_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					grade: "",
					title:'',
					disabledcwbbxqykjzz_0_x_1:false,
					disabledcwbbxqykjzz_0_x_2:false,
					cwbbxqykjzz_0_x_1: {
						cellCode:"cwbbxqykjzz_0_22_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_0_x_2: {
						cellCode:"cwbbxqykjzz_0_22_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					grade: "",
					title:'',
					disabledcwbbxqykjzz_0_x_1:false,
					disabledcwbbxqykjzz_0_x_2:false,
					cwbbxqykjzz_0_x_1: {
						cellCode:"cwbbxqykjzz_0_23_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_0_x_2: {
						cellCode:"cwbbxqykjzz_0_23_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					grade: "",
					title:'所有者权益（或股东权益）：',
					disabledcwbbxqykjzz_0_x_1:true,
					disabledcwbbxqykjzz_0_x_2:true,
					cwbbxqykjzz_0_x_1: {
						cellCode:"cwbbxqykjzz_0_12_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_0_x_2: {
						cellCode:"cwbbxqykjzz_0_12_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					grade: "48",
					title:'实收资本（或股本）',
					disabledcwbbxqykjzz_0_x_1:false,
					disabledcwbbxqykjzz_0_x_2:false,
					cwbbxqykjzz_0_x_1: {
						cellCode:"cwbbxqykjzz_0_25_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_0_x_2: {
						cellCode:"cwbbxqykjzz_0_25_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					grade: "49",
					title:'资本公积',
					disabledcwbbxqykjzz_0_x_1:false,
					disabledcwbbxqykjzz_0_x_2:false,
					cwbbxqykjzz_0_x_1: {
						cellCode:"cwbbxqykjzz_0_26_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_0_x_2: {
						cellCode:"cwbbxqykjzz_0_26_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					grade: "50",
					title:'盈余公积',
					disabledcwbbxqykjzz_0_x_1:false,
					disabledcwbbxqykjzz_0_x_2:false,
					cwbbxqykjzz_0_x_1: {
						cellCode:"cwbbxqykjzz_0_27_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_0_x_2: {
						cellCode:"cwbbxqykjzz_0_27_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					grade: "51",
					title:'未分配利润',
					disabledcwbbxqykjzz_0_x_1:false,
					disabledcwbbxqykjzz_0_x_2:false,
					cwbbxqykjzz_0_x_1: {
						cellCode:"cwbbxqykjzz_0_28_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_0_x_2: {
						cellCode:"cwbbxqykjzz_0_28_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					grade: "52",
					title:'所有者权益（或股东权益）合计',
					disabledcwbbxqykjzz_0_x_1:false,
					disabledcwbbxqykjzz_0_x_2:false,
					cwbbxqykjzz_0_x_1: {
						cellCode:"cwbbxqykjzz_0_29_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_0_x_2: {
						cellCode:"cwbbxqykjzz_0_29_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					grade: "53",
					title:'负债和所有者权益（或股东权益）总计',
					disabledcwbbxqykjzz_0_x_1:false,
					disabledcwbbxqykjzz_0_x_2:false,
					cwbbxqykjzz_0_x_1: {
						cellCode:"cwbbxqykjzz_0_30_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_0_x_2: {
						cellCode:"cwbbxqykjzz_0_30_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
			],
			tableData: [{
					title: "货币资金",
					grade: "1",
					disabledcwbbxqykjzz_0_x_1:false,
					disabledcwbbxqykjzz_0_x_2:false,
					cwbbxqykjzz_0_x_1: {
						cellCode:"cwbbxqykjzz_0_1_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_0_x_2: {
						cellCode:"cwbbxqykjzz_0_1_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
				{
					title: "短期投资",
					grade: "2",
					disabledcwbbxqykjzz_0_x_1:false,
					disabledcwbbxqykjzz_0_x_2:false,
					cwbbxqykjzz_0_x_1: {
						cellCode:"cwbbxqykjzz_0_2_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_0_x_2: {
						cellCode:"cwbbxqykjzz_0_2_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "应收票据",
					grade: "3",
					disabledcwbbxqykjzz_0_x_1:false,
					disabledcwbbxqykjzz_0_x_2:false,
					cwbbxqykjzz_0_x_1: {
						cellCode:"cwbbxqykjzz_0_3_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_0_x_2: {
						cellCode:"cwbbxqykjzz_0_3_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "应收账款",
					grade: "4",
					disabledcwbbxqykjzz_0_x_1:false,
					disabledcwbbxqykjzz_0_x_2:false,
					cwbbxqykjzz_0_x_1: {
						cellCode:"cwbbxqykjzz_0_4_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_0_x_2: {
						cellCode:"cwbbxqykjzz_0_4_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "预付账款",
					grade: "5",
					disabledcwbbxqykjzz_0_x_1:false,
					disabledcwbbxqykjzz_0_x_2:false,
					cwbbxqykjzz_0_x_1: {
						cellCode:"cwbbxqykjzz_0_5_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_0_x_2: {
						cellCode:"cwbbxqykjzz_0_5_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "应收股利",
					grade: "6",
					disabledcwbbxqykjzz_0_x_1:false,
					disabledcwbbxqykjzz_0_x_2:false,
					cwbbxqykjzz_0_x_1: {
						cellCode:"cwbbxqykjzz_0_6_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_0_x_2: {
						cellCode:"cwbbxqykjzz_0_6_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "应收利息",
					grade: "7",
					disabledcwbbxqykjzz_0_x_1:false,
					disabledcwbbxqykjzz_0_x_2:false,
					cwbbxqykjzz_0_x_1: {
						cellCode:"cwbbxqykjzz_0_7_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_0_x_2: {
						cellCode:"cwbbxqykjzz_0_7_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "其他应收款",
					grade: "8",
					disabledcwbbxqykjzz_0_x_1:false,
					disabledcwbbxqykjzz_0_x_2:false,
					cwbbxqykjzz_0_x_1: {
						cellCode:"cwbbxqykjzz_0_8_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_0_x_2: {
						cellCode:"cwbbxqykjzz_0_8_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "存货",
					grade: "9",
					disabledcwbbxqykjzz_0_x_1:false,
					disabledcwbbxqykjzz_0_x_2:false,
					cwbbxqykjzz_0_x_1: {
						cellCode:"cwbbxqykjzz_0_9_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_0_x_2: {
						cellCode:"cwbbxqykjzz_0_9_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "其中：原材料",
					grade: "10",
					disabledcwbbxqykjzz_0_x_1:false,
					disabledcwbbxqykjzz_0_x_2:false,
					cwbbxqykjzz_0_x_1: {
						cellCode:"cwbbxqykjzz_0_10_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_0_x_2: {
						cellCode:"cwbbxqykjzz_0_10_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "在产品",
					grade: "11",
					disabledcwbbxqykjzz_0_x_1:false,
					disabledcwbbxqykjzz_0_x_2:false,
					cwbbxqykjzz_0_x_1: {
						cellCode:"cwbbxqykjzz_0_11_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_0_x_2: {
						cellCode:"cwbbxqykjzz_0_11_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "库存商品",
					grade: "12",
					disabledcwbbxqykjzz_0_x_1:false,
					disabledcwbbxqykjzz_0_x_2:false,
					cwbbxqykjzz_0_x_1: {
						cellCode:"cwbbxqykjzz_0_12_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_0_x_2: {
						cellCode:"cwbbxqykjzz_0_12_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "周转材料",
					grade: "13",
					disabledcwbbxqykjzz_0_x_1:false,
					disabledcwbbxqykjzz_0_x_2:false,
					cwbbxqykjzz_0_x_1: {
						cellCode:"cwbbxqykjzz_0_13_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_0_x_2: {
						cellCode:"cwbbxqykjzz_0_13_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "其他流动资产",
					grade: "14",
					disabledcwbbxqykjzz_0_x_1:false,
					disabledcwbbxqykjzz_0_x_2:false,
					cwbbxqykjzz_0_x_1: {
						cellCode:"cwbbxqykjzz_0_14_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_0_x_2: {
						cellCode:"cwbbxqykjzz_0_14_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "流动资产合计",
					grade: "15",
					disabledcwbbxqykjzz_0_x_1:false,
					disabledcwbbxqykjzz_0_x_2:false,
					cwbbxqykjzz_0_x_1: {
						cellCode:"cwbbxqykjzz_0_15_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_0_x_2: {
						cellCode:"cwbbxqykjzz_0_15_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "非流动资产",
					grade: "",
					disabledcwbbxqykjzz_0_x_1:true,
					disabledcwbbxqykjzz_0_x_2:true,
					cwbbxqykjzz_0_x_1: {},
					cwbbxqykjzz_0_x_2: {},
				},{
					title: "长期债券投资",
					grade: "16",
					disabledcwbbxqykjzz_0_x_1:false,
					disabledcwbbxqykjzz_0_x_2:false,
					cwbbxqykjzz_0_x_1: {
						cellCode:"cwbbxqykjzz_0_16_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_0_x_2: {
						cellCode:"cwbbxqykjzz_0_16_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "长期股权投资",
					grade: "17",
					disabledcwbbxqykjzz_0_x_1:false,
					disabledcwbbxqykjzz_0_x_2:false,
					cwbbxqykjzz_0_x_1: {
						cellCode:"cwbbxqykjzz_0_17_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_0_x_2: {
						cellCode:"cwbbxqykjzz_0_17_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "固定资产原价",
					grade: "18",
					disabledcwbbxqykjzz_0_x_1:false,
					disabledcwbbxqykjzz_0_x_2:false,
					cwbbxqykjzz_0_x_1: {
						cellCode:"cwbbxqykjzz_0_18_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_0_x_2: {
						cellCode:"cwbbxqykjzz_0_18_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "减：累计折旧",
					grade: "19",
					disabledcwbbxqykjzz_0_x_1:false,
					disabledcwbbxqykjzz_0_x_2:false,
					cwbbxqykjzz_0_x_1: {
						cellCode:"cwbbxqykjzz_0_19_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_0_x_2: {
						cellCode:"cwbbxqykjzz_0_19_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "固定资产账面价值",
					grade: "20",
					disabledcwbbxqykjzz_0_x_1:false,
					disabledcwbbxqykjzz_0_x_2:false,
					cwbbxqykjzz_0_x_1: {
						cellCode:"cwbbxqykjzz_0_20_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_0_x_2: {
						cellCode:"cwbbxqykjzz_0_20_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "在建工程",
					grade: "21",
					disabledcwbbxqykjzz_0_x_1:false,
					disabledcwbbxqykjzz_0_x_2:false,
					cwbbxqykjzz_0_x_1: {
						cellCode:"cwbbxqykjzz_0_21_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_0_x_2: {
						cellCode:"cwbbxqykjzz_0_21_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "工程物资",
					grade: "22",
					disabledcwbbxqykjzz_0_x_1:false,
					disabledcwbbxqykjzz_0_x_2:false,
					cwbbxqykjzz_0_x_1: {
						cellCode:"cwbbxqykjzz_0_22_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_0_x_2: {
						cellCode:"cwbbxqykjzz_0_22_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "固定资产清理",
					grade: "23",
					disabledcwbbxqykjzz_0_x_1:false,
					disabledcwbbxqykjzz_0_x_2:false,
					cwbbxqykjzz_0_x_1: {
						cellCode:"cwbbxqykjzz_0_23_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_0_x_2: {
						cellCode:"cwbbxqykjzz_0_23_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "生物性生物资产",
					grade: "24",
					disabledcwbbxqykjzz_0_x_1:false,
					disabledcwbbxqykjzz_0_x_2:false,
					cwbbxqykjzz_0_x_1: {
						cellCode:"cwbbxqykjzz_0_12_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_0_x_2: {
						cellCode:"cwbbxqykjzz_0_12_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "无形资产",
					grade: "25",
					disabledcwbbxqykjzz_0_x_1:false,
					disabledcwbbxqykjzz_0_x_2:false,
					cwbbxqykjzz_0_x_1: {
						cellCode:"cwbbxqykjzz_0_25_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_0_x_2: {
						cellCode:"cwbbxqykjzz_0_25_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "  开发支出",
					grade: "26",
					disabledcwbbxqykjzz_0_x_1:false,
					disabledcwbbxqykjzz_0_x_2:false,
					cwbbxqykjzz_0_x_1: {
						cellCode:"cwbbxqykjzz_0_26_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_0_x_2: {
						cellCode:"cwbbxqykjzz_0_26_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "长期待摊费用",
					grade: "27",
					disabledcwbbxqykjzz_0_x_1:false,
					disabledcwbbxqykjzz_0_x_2:false,
					cwbbxqykjzz_0_x_1: {
						cellCode:"cwbbxqykjzz_0_27_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_0_x_2: {
						cellCode:"cwbbxqykjzz_0_27_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "其他非流动资产",
					grade: "28",
					disabledcwbbxqykjzz_0_x_1:false,
					disabledcwbbxqykjzz_0_x_2:false,
					cwbbxqykjzz_0_x_1: {
						cellCode:"cwbbxqykjzz_0_28_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_0_x_2: {
						cellCode:"cwbbxqykjzz_0_28_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "非流动资产合计",
					grade: "29",
					disabledcwbbxqykjzz_0_x_1:false,
					disabledcwbbxqykjzz_0_x_2:false,
					cwbbxqykjzz_0_x_1: {
						cellCode:"cwbbxqykjzz_0_29_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_0_x_2: {
						cellCode:"cwbbxqykjzz_0_29_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "资产合计",
					grade: "30",
					disabledcwbbxqykjzz_0_x_1:false,
					disabledcwbbxqykjzz_0_x_2:false,
					cwbbxqykjzz_0_x_1: {
						cellCode:"cwbbxqykjzz_0_30_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_0_x_2: {
						cellCode:"cwbbxqykjzz_0_30_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},
			]
	}
	return obj
}
